/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CreateBoardList } from './boardList';

export function Errata(routeProps: RouteComponentProps) {
  useEffect(() => {}, []);

  return (
    <div className="content">
      {CreateBoardList(
        routeProps,
        {
          title: '정오표',
          subTitle: '도서출판 구민사의 정오표입니다.',
          visableButton: false,
          ctgy: 'errata',
          viewUrl: '/board/boardView',
        },
        () => {},
        false
      )}
    </div>
  );
}
